// @ts-nocheck
/**
 * terrainControls.ts
 * 3D・地形コントロール関連メソッド
 * App.vue から切り出し
 */

import { closeAllPopups } from '@/js/popup'
import { showLoginPrompt } from '@/js/utils/messageHelper'

type VM = any

export function btnPosition(vm: VM) {
  try {
    if (document.querySelector('#map01').clientWidth < Number(document.querySelector('.terrain-btn-div').style.left.replace('px', ''))) {
      document.querySelector('.terrain-btn-div').style.left = ''
      document.querySelector('.terrain-btn-div').style.right = '10px'
    }
  } catch (e) {
  }
}

export function terrainBtnClos() {
  document.querySelectorAll('.terrain-btn-div').forEach(elm => {
    elm.style.display = 'none'
  })
  document.querySelectorAll('.terrain-btn-expand-div').forEach(elm => {
    elm.style.display = 'block'
  })
}

// 3Dオフ：テレインOFF、pitch/bearing を 0 にリセット、コントローラー非表示
export function terrain3dOff(vm: VM) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  // テレインをオフ
  if (map01) map01.setTerrain(null)
  if (map02) map02.setTerrain(null)
  vm.$store.state.isTerrainEnabled = false
  // pitch/bearing をリセット
  if (map01) map01.easeTo({ bearing: 0, pitch: 0, duration: 600 })
  if (map02) map02.easeTo({ bearing: 0, pitch: 0, duration: 600 })
  // 3Dコントローラーを非表示
  document.querySelectorAll('.terrain-btn-div').forEach(elm => {
    elm.style.display = 'none'
  })
  document.querySelectorAll('.terrain-btn-expand-div').forEach(elm => {
    elm.style.display = 'block'
  })
  // パーマリンク更新（アニメーション終了後）
  setTimeout(() => {
    vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire
  }, 600)
}

export function terrainBtnExpand() {
  document.querySelectorAll('.terrain-btn-div').forEach(elm => {
    elm.style.display = 'block'
  })
  document.querySelectorAll('.terrain-btn-expand-div').forEach(elm => {
    elm.style.display = 'none'
  })
}

// 3Dメニューから選択：テレインあり/なしを指定して3D表示
export function terrainBtnExpandWithTerrain(vm: VM, withTerrain) {
  // 3Dコントロールを表示
  terrainBtnExpand()
  // テレイン状態を設定
  vm.$store.state.isTerrainEnabled = withTerrain
  // 地図にテレインを適用
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (withTerrain) {
    if (map01 && map01.getSource('terrain')) {
      map01.setTerrain({ 'source': 'terrain', 'exaggeration': vm.s_terrainLevel })
    }
    if (map02 && map02.getSource('terrain')) {
      map02.setTerrain({ 'source': 'terrain', 'exaggeration': vm.s_terrainLevel })
    }
  } else {
    if (map01) map01.setTerrain(null)
    if (map02) map02.setTerrain(null)
  }
  // ピッチを60度に設定
  if (map01) map01.easeTo({ pitch: 60, duration: 600 })
  if (map02) map02.easeTo({ pitch: 60, duration: 600 })
  // パーマリンク更新（アニメーション終了後）
  setTimeout(() => {
    vm.$store.state.updatePermalinkFire = !vm.$store.state.updatePermalinkFire
  }, 600)
}

// 標高強調スライダー変更
export function terrainLevelInput(vm: VM) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (map01 && map01.getTerrain()) {
    map01.setTerrain({ 'source': 'terrain', 'exaggeration': vm.s_terrainLevel })
  }
  if (map02 && map02.getTerrain()) {
    map02.setTerrain({ 'source': 'terrain', 'exaggeration': vm.s_terrainLevel })
  }
  localStorage.setItem('terrainLevel', vm.s_terrainLevel)
}

// 3Dメニューハンドラ（コントローラー内のドロップダウン用）
export function handle3dOff(vm: VM, mapName) {
  terrain3dOff(vm)
  vm.terrain3dMenu1s[mapName] = false
}

export function handle3dNoTerrain(vm: VM, mapName) {
  terrainBtnExpandWithTerrain(vm, false)
  vm.terrain3dMenu1s[mapName] = false
}

export function handle3dWithTerrain(vm: VM, mapName) {
  terrainBtnExpandWithTerrain(vm, true)
  vm.terrain3dMenu1s[mapName] = false
}

// 3Dメニューハンドラ（FAB用）
export function handle3dOffFab(vm: VM) {
  terrain3dOff(vm)
  vm.terrain3dMenu2 = false
}

export function handle3dNoTerrainFab(vm: VM) {
  terrainBtnExpandWithTerrain(vm, false)
  vm.terrain3dMenu2 = false
}

export function handle3dWithTerrainFab(vm: VM) {
  terrainBtnExpandWithTerrain(vm, true)
  vm.terrain3dMenu2 = false
}

// 3Dジオラマを開く
export function openDiorama3D(vm: VM, mapName) {
  // FW・ドロワー・ポップアップを全て閉じる
  const st = vm.$store.state
  Object.keys(st.floatingWindows).forEach(id => { st.floatingWindows[id] = false })
  st.showDrawDrawer = false
  st.showDrawListDrawer = false
  st.showAboutDrawer = false
  st.showPointInfoDrawer = false
  st.showRightDrawer = false
  st.showChibanzuDrawer = false
  st.popupDialog = false
  if (typeof closeAllPopups === 'function') closeAllPopups()

  st.isDiorama3D = true
  vm.terrain3dMenu1s[mapName] = false
  vm.terrain3dMenu2 = false
}

// マイルームボタンクリック（ログインチェック付き）
export function onMyroomClick(vm: VM, mapName) {
  if (!vm.userId) {
    showLoginPrompt({
      title: 'マイルーム',
      message: 'マイルームはログインユーザー専用の機能です。<br>ご利用いただくには、ログインしてください。',
      icon: 'mdi-home',
    })
    return
  }
  btnClickMyroom(vm, mapName)
}

export function btnClickMyroom(vm: VM, mapName) {
  // FloatingWindow用に修正
  const windowId = 'myroom-window-' + mapName
  const currentVisible = vm.$store.state.floatingWindows[windowId]
  if (currentVisible) {
    vm.$store.dispatch('hideFloatingWindow', windowId)
  } else {
    vm.$store.dispatch('showFloatingWindow', windowId)
  }

  if (vm.s_isAndroid) {
    let startY
    let isTouching = false
    let currentTarget = null
    let initialScrollTop = 0
    document.addEventListener('touchstart', (e) => {
      const target = e.target.closest('.myroom-content-scroll')
      if (target) {
        startY = e.touches[0].clientY
        initialScrollTop = target.scrollTop
        isTouching = true
        currentTarget = target
        target.style.overflowY = 'auto'
        target.style.touchAction = 'manipulation'
        e.stopPropagation()
      }
    }, { passive: true, capture: true })

    document.addEventListener('touchmove', (e) => {
      if (!isTouching || !currentTarget) return
      const moveY = e.touches[0].clientY
      const deltaY = startY - moveY
      currentTarget.scrollTop += deltaY
      startY = moveY
      e.preventDefault()
      e.stopPropagation()
    }, { passive: false, capture: true })

    document.addEventListener('touchend', () => {
      if (currentTarget) {
        currentTarget.style.overflowY = ''
      }
      currentTarget = null
      isTouching = false
      initialScrollTop = 0
    }, { passive: true })
  }
}
